import * as React from 'react';
import {SFC} from 'react';
import {Popover} from '../popover/popover';

interface IConsoleScrollHintProps {
  visible: boolean;
  onHide?: () => void;
}

export const ConsoleScrollHint: SFC<IConsoleScrollHintProps> = ({visible, onHide}) => (
  <Popover
    visible={visible}
    message={'Did you notice the scroll bar?'}
    isHint={true}
    onHide={onHide}
  />
);
